import React from 'react';
import { useTranslation } from 'react-i18next';

export const CollectionProductImage: React.FC<{
    imageSrc: string;
}> = (props) => {
    const { imageSrc } = props;
    const { t } = useTranslation();

    return (
        <>
            <img
                src={imageSrc ? imageSrc : '/assets/no-image_200x.webp'}
                // alt={
                //     product.featuredImage && product.featuredImage.altText
                //         ? product.featuredImage.altText
                //         : product.title
                // }
            />
        </>
    );
};
